/**
 * System Settings API Client
 */

import { apiCall } from '../api';
import type {
  SystemSettingsResponse,
  UpdateSystemSettingsRequest,
} from '@/types/api';

export async function fetchSystemSettings(): Promise<SystemSettingsResponse> {
  return await apiCall<SystemSettingsResponse>('/api/system-settings', {
    method: 'GET',
  });
}

export async function updateSystemSettings(
  data: UpdateSystemSettingsRequest
): Promise<SystemSettingsResponse> {
  return await apiCall<SystemSettingsResponse>('/api/system-settings', {
    method: 'PUT',
    body: JSON.stringify(data),
  });
}
